import { observer } from 'mobx-react-lite';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

import { BrandedLoadingScreen } from './BrandedLoadingScreen';

export interface SpinnerLayoutProps {
	// When true the branded loader is always shown and the outlet renders underneath it (invisible /
	// redirect-only routes such as the Epic login hop, and RootLayout's global chunk-cascade fallback).
	// When false (default) the loader is only the Suspense fallback and the resolved outlet replaces it.
	readonly keepSpinnerVisible?: boolean;
}

export const SpinnerLayout = observer(function SpinnerLayout({ keepSpinnerVisible = false }: SpinnerLayoutProps) {
	if (keepSpinnerVisible) {
		return (
			<BrandedLoadingScreen>
				<Suspense fallback={null}>
					<Outlet />
				</Suspense>
			</BrandedLoadingScreen>
		);
	}

	return (
		<Suspense fallback={<BrandedLoadingScreen />}>
			<Outlet />
		</Suspense>
	);
});
